export function formatEuro (price: number, noEuro?: boolean, freeBelowZero?: boolean): string {
    const value = price.toLocaleString('it-IT', {
        style: 'currency',
        currency: 'EUR'
    });

    if (noEuro) {
        return value.replace('€', '').trim();
    } else if ((freeBelowZero && price <= 0) || price === 0) {
        return 'kostenlos';
    }

    return value;
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/format-euro.ts